<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['getLoad'])
    },
    methods: {
      ...mapMutations(['openGlobalLoad', 'closeGlobalLoad'])
    },
    name: 'GlobalLoading'
  }
</script>
